// store/slices/themeSlice.js
import { createSlice } from '@reduxjs/toolkit';

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    mode: 'light', // 'light' or 'dark'
  },
  reducers: {
    /**
     * Toggles between light and dark mode
     */
    toggleTheme: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    
    /**
     * Sets a specific theme mode
     * @param {string} action.payload - 'light' or 'dark'
     */
    setThemeMode: (state, action) => {
      state.mode = action.payload;
    }
  }
});

export const { toggleTheme, setThemeMode } = themeSlice.actions;
export default themeSlice.reducer;